import { authenticatedUser } from 'header-scripts';
import { dataStores } from 'core-roblox-utilities';
import presenceTypes from '../constants/presenceTypes';

const { userDataStore } = dataStores;

const getFriendsPresenceData = handleFriendsPresenceData => {
  return userDataStore.subscribeToFriends({
    callback: handleFriendsPresenceData,
    userId: authenticatedUser?.id,
    isGuest: false,
    cacheCriteria: {
      isEnabled: true,
      expirationMS: 30000
    }
  });
};

const getFriendsInGame = (friendsPresenceData, currentUniverseId) => {
  const userIdsInUniverses = [];
  friendsPresenceData.forEach(friendPresence => {
    if (friendPresence?.presence) {
      const { universeId, userId } = friendPresence.presence;
      if (
        universeId === currentUniverseId &&
        friendPresence?.presence?.userPresenceType === presenceTypes.ingame.status
      ) {
        userIdsInUniverses.push(userId);
      }
    }
  });
  return userIdsInUniverses;
};

export default {
  getFriendsPresenceData,
  getFriendsInGame
};
